// Chamber schedule per doctor. Times are 24h "HH:MM". `title` is the heading shown in the timetable cell.
// `slotMinutes` controls the time options offered in the appointment form.
// Friday is OPD-closed (see siteConfig.openingHours).

// Column order of the timetable grid (same as the original site)
export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const timetable = [
  // Prof. Dr. Md. Rafiqul Islam
  { id: 1, doctorId: 1, day: "Saturday", start: "16:00", end: "20:00", title: "Psychiatry", type: "Consultation", slotMinutes: 30 },
  { id: 2, doctorId: 1, day: "Monday", start: "16:00", end: "20:00", title: "Psychiatry", type: "Consultation", slotMinutes: 30 },
  { id: 3, doctorId: 1, day: "Wednesday", start: "16:00", end: "20:00", title: "Psychiatry", type: "Consultation", slotMinutes: 30 },

  // Dr. Mahmudul Hasan
  { id: 4, doctorId: 2, day: "Saturday", start: "10:00", end: "13:00", title: "De-Addiction", type: "Consultation", slotMinutes: 30 },
  { id: 5, doctorId: 2, day: "Sunday", start: "17:00", end: "21:00", title: "De-Addiction", type: "Consultation", slotMinutes: 30 },
  { id: 6, doctorId: 2, day: "Tuesday", start: "17:00", end: "21:00", title: "De-Addiction", type: "Consultation", slotMinutes: 30 },
  { id: 7, doctorId: 2, day: "Thursday", start: "10:00", end: "13:00", title: "De-Addiction", type: "Consultation", slotMinutes: 30 },

  // Dr. Nasrin Sultana
  { id: 8, doctorId: 3, day: "Sunday", start: "10:00", end: "14:00", title: "Psychiatry", type: "Consultation", slotMinutes: 30 },
  { id: 9, doctorId: 3, day: "Tuesday", start: "10:00", end: "14:00", title: "Psychiatry", type: "Consultation", slotMinutes: 30 },
  { id: 10, doctorId: 3, day: "Thursday", start: "16:00", end: "20:00", title: "Psychiatry", type: "Consultation", slotMinutes: 30 },

  // Dr. Tanvir Ahmed (OPD hours; ward duty outside these)
  { id: 11, doctorId: 4, day: "Saturday", start: "09:00", end: "13:00", title: "General Psychiatry", type: "Consultation", slotMinutes: 20 },
  { id: 12, doctorId: 4, day: "Sunday", start: "09:00", end: "13:00", title: "General Psychiatry", type: "Consultation", slotMinutes: 20 },
  { id: 13, doctorId: 4, day: "Monday", start: "09:00", end: "13:00", title: "General Psychiatry", type: "Consultation", slotMinutes: 20 },
  { id: 14, doctorId: 4, day: "Tuesday", start: "09:00", end: "13:00", title: "General Psychiatry", type: "Consultation", slotMinutes: 20 },
  { id: 15, doctorId: 4, day: "Wednesday", start: "09:00", end: "13:00", title: "General Psychiatry", type: "Consultation", slotMinutes: 20 },
  { id: 16, doctorId: 4, day: "Thursday", start: "09:00", end: "13:00", title: "General Psychiatry", type: "Consultation", slotMinutes: 20 },

  // Md. Arif Hossain (therapy sessions)
  { id: 17, doctorId: 5, day: "Saturday", start: "11:00", end: "17:00", title: "Psychotherapy", type: "Therapy", slotMinutes: 60 },
  { id: 18, doctorId: 5, day: "Monday", start: "11:00", end: "17:00", title: "Psychotherapy", type: "Therapy", slotMinutes: 60 },
  { id: 19, doctorId: 5, day: "Wednesday", start: "11:00", end: "17:00", title: "Psychotherapy", type: "Therapy", slotMinutes: 60 },

  // Shahidul Alam (counseling sessions)
  { id: 20, doctorId: 6, day: "Sunday", start: "10:00", end: "16:00", title: "Counseling", type: "Counseling", slotMinutes: 60 },
  { id: 21, doctorId: 6, day: "Tuesday", start: "10:00", end: "16:00", title: "Counseling", type: "Counseling", slotMinutes: 60 },
  { id: 22, doctorId: 6, day: "Thursday", start: "10:00", end: "16:00", title: "Counseling", type: "Counseling", slotMinutes: 60 },
];

export default timetable;
